import { Component, Input } from '@angular/core';
import { EinreichungStep } from '@ebeihilfe/einreichung-old';

export const numberToText: { [key: number]: string } = {
  1: 'one',
  2: 'two',
  3: 'three',
};

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'portal-single-step',
    templateUrl: './single-step.component.html',
    styleUrls: ['./single-step.component.scss'],
    standalone: false
})
export class SingleStepComponent {
  @Input() public currentStep: EinreichungStep;
  @Input() public stepActive: boolean;
  @Input() public stepDone: boolean;
  @Input() public stepNumber: keyof typeof numberToText;

  public get writtenNumber(): string {
    return numberToText[this.stepNumber];
  }
}
